import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "categorie-form" }

import AccessoireForm from './AccessoireForm.vue';
import { IProduct } from '@/model/Product';
import { computed } from '@vue/reactivity';
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  accessoires: {type: Array as PropType<IProduct[]>, default: () => []},
  categorie: {type: String as PropType<string>, default: () => undefined},
  lame: {type: Object as PropType<IProduct | undefined>, default: () => undefined},
},
  emits: ['update', 'updateInfo'],
  setup(__props, { emit: emits }) {

const props = __props



const categorieAccessoires = computed(() => {
  return props.accessoires
    .filter(p => p.sous_categorie === props.categorie)
    .filter((p, index, self) => self.map(pr => pr.description_base).indexOf(p.description_base) === index)
})



const update = (value: any) => {
  emits('update', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categorieAccessoires), (accessoire) => {
      return (_openBlock(), _createElementBlock("div", {
        key: accessoire.idd
      }, [
        _createVNode(AccessoireForm, {
          accessoire: accessoire,
          accessoires: __props.accessoires,
          lame: __props.lame,
          onUpdate: _cache[0] || (_cache[0] = ($event: any) => (update($event))),
          onUpdateInfo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateInfo', $event)))
        }, null, 8, ["accessoire", "accessoires", "lame"])
      ]))
    }), 128))
  ]))
}
}

})